(function () {
  function initTestimonials(root) {
    if (root.getAttribute('data-amc-eif-testimonials-init') === 'true') return;
    root.setAttribute('data-amc-eif-testimonials-init', 'true');

    var viewport = root.querySelector('.amc-eif__testimonials-viewport');
    var track = root.querySelector('[data-amc-eif-track]');
    var cards = track ? Array.prototype.slice.call(track.querySelectorAll('[data-amc-eif-card]')) : [];
    var prevBtn = root.querySelector('[data-amc-eif-prev]');
    var nextBtn = root.querySelector('[data-amc-eif-next]');
    var total = cards.length;

    if (!track || !viewport || total === 0) return;

    var mobileQuery = window.matchMedia('(max-width: 989px)');
    var offset = 0;
    var scrollRaf = null;

    function isMobile() {
      return mobileQuery.matches;
    }

    function getVisible() {
      return isMobile() ? 1 : 2;
    }

    function stepSize() {
      if (!cards[0]) return 0;
      var cardWidth = cards[0].offsetWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      return cardWidth + gap;
    }

    function maxOffset() {
      return Math.max(0, total - getVisible());
    }

    function clampOffset() {
      var max = maxOffset();
      if (offset > max) offset = max;
      if (offset < 0) offset = 0;
    }

    function updateButtons() {
      clampOffset();
      var visible = getVisible();
      var max = maxOffset();
      if (prevBtn) {
        prevBtn.disabled = offset <= 0;
        prevBtn.hidden = total <= visible;
      }
      if (nextBtn) {
        nextBtn.disabled = offset >= max;
        nextBtn.hidden = total <= visible;
      }
    }

    function syncOffsetFromScroll() {
      var step = stepSize();
      if (!step) return;
      offset = Math.round(viewport.scrollLeft / step);
      updateButtons();
    }

    function render() {
      clampOffset();
      var step = stepSize();
      if (isMobile()) {
        track.style.transform = '';
        viewport.scrollLeft = offset * step;
      } else {
        track.style.transform = 'translateX(' + -offset * step + 'px)';
      }
      updateButtons();
    }

    function goTo(nextOffset) {
      offset = nextOffset;
      if (isMobile()) {
        clampOffset();
        var step = stepSize();
        viewport.scrollTo({ left: offset * step, behavior: 'smooth' });
        updateButtons();
      } else {
        render();
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (offset <= 0) return;
        goTo(offset - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (offset >= maxOffset()) return;
        goTo(offset + 1);
      });
    }

    viewport.addEventListener(
      'scroll',
      function () {
        if (!isMobile()) return;
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = null;
          syncOffsetFromScroll();
        });
      },
      { passive: true }
    );

    function onLayoutChange() {
      if (isMobile()) {
        track.style.transform = '';
        syncOffsetFromScroll();
      } else {
        render();
      }
    }

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', onLayoutChange);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(onLayoutChange);
    }

    window.addEventListener('resize', onLayoutChange);
    render();
  }

  function initSection(section) {
    if (!section || section.getAttribute('data-amc-eif-section-init') === 'true') return;
    section.setAttribute('data-amc-eif-section-init', 'true');

    var testimonials = section.querySelector('[data-amc-eif-testimonials]');
    if (testimonials) initTestimonials(testimonials);

    var successMessage = section.querySelector('.amc-eif-contact-form__message--success');
    if (successMessage) {
      successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-amc-eif-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector('[data-amc-eif-section]');
    if (!section) return;
    section.removeAttribute('data-amc-eif-section-init');
    initSection(section);
  });
})();
